import { useEnvStore } from '@/stores/envStore'
import { useAuthStore } from '@/stores/authStore'
import axios from 'axios'
import { InjectionKey } from 'vue'

export default class AuthorizationInterceptor {
  envStore = useEnvStore()

  public enable() {
    const authStore = useAuthStore()

    axios.interceptors.request.use(async (request) => {
      if (
        request.url?.startsWith(this.envStore.variables.ANALYZE_API_BACKEND_URL) ||
        request.url?.startsWith(this.envStore.variables.ANALYZE_PLATFORM_URL)
      ) {
        const accessToken = authStore.accessToken

        if (accessToken && authStore.isTokenExpired) {
          // Attempt to refresh the token
          try {
            await authStore.refreshAccessToken()
            request.headers.Authorization = `Bearer ${authStore.accessToken}`
          } catch (error) {
            // Handle refresh token failure, trigger OIDC login directly
            console.error('Token refresh failed, redirecting to login', error)
            await authStore.signIn()
          }
        } else if (accessToken) {
          request.headers.Authorization = `Bearer ${accessToken}`
        }
      }
      return request
    })

    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response && error.response.status === 401) {
          console.error('Got status 401. Triggering login.', error)
          await authStore.signIn()
        }
        return Promise.reject(error)
      },
    )
  }
}
export const AUTHZ_INTERCEPTOR_KEY: InjectionKey<AuthorizationInterceptor> = Symbol(
  'AuthorizationInterceptor',
)
